import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { LicensesPageComponent } from './licenses-page/licenses.page.component';
import { LicenseCardComponent } from './license-card/license.card.component';
import { DeviceCardComponent } from './device-card/device-card.component';

@NgModule({
  imports: [CommonModule, BrowserAnimationsModule, CommonMaterialModule, CommonLibModule],
  declarations: [LicensesPageComponent, LicenseCardComponent, DeviceCardComponent],
  exports: [LicensesPageComponent, LicenseCardComponent, DeviceCardComponent]
})
export class LicensesModule {}
